var _g, _rect, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h0frbs3nza)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 129,
    height: 129,
    rx: 64.5,
    fill: "url(#9bqu1hjt4b)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "tgxo7bkd7d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 129,
    height: 129
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 129,
    height: 129,
    rx: 64.5,
    fill: "url(#l84qor77nc)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tgxo7bkd7d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M94.44 128.547c0-1.646.669-3.224 1.858-4.387a6.408 6.408 0 0 1 4.482-1.817h12.68a6.414 6.414 0 0 0 4.483-1.817 6.14 6.14 0 0 0 1.857-4.387 6.14 6.14 0 0 0-1.857-4.387 6.414 6.414 0 0 0-4.483-1.817H75.421a6.409 6.409 0 0 1-4.483-1.817 6.135 6.135 0 0 1-1.856-4.386c0-1.646.667-3.224 1.856-4.387a6.411 6.411 0 0 1 4.483-1.817h12.68a6.41 6.41 0 0 0 4.483-1.817 6.137 6.137 0 0 0 1.857-4.387 6.137 6.137 0 0 0-1.857-4.386A6.411 6.411 0 0 0 88.1 85.12H50.062a6.411 6.411 0 0 1-4.483-1.817 6.137 6.137 0 0 1-1.857-4.387c0-1.645.668-3.224 1.857-4.387a6.411 6.411 0 0 1 4.483-1.817h12.68a6.41 6.41 0 0 0 4.483-1.817 6.137 6.137 0 0 0 1.857-4.387 6.137 6.137 0 0 0-1.857-4.386 6.411 6.411 0 0 0-4.483-1.817H24.703a6.411 6.411 0 0 1-4.483-1.817 6.137 6.137 0 0 1-1.857-4.387c0-1.645.668-3.223 1.857-4.387a6.411 6.411 0 0 1 4.483-1.817h12.68a6.41 6.41 0 0 0 4.482-1.817 6.137 6.137 0 0 0 1.857-4.387 6.137 6.137 0 0 0-1.857-4.386 6.411 6.411 0 0 0-4.482-1.817H13.29C7.073 47.4 4.567 60.834 6.086 74.125c1.52 13.29 6.996 25.852 15.749 36.122 8.753 10.271 20.398 17.798 33.486 21.647a71.207 71.207 0 0 0 40.134.003 6.111 6.111 0 0 1-1.014-3.35z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.273 31.973c-2.582-3.95-5.877-7.001-9.304-10.175-.415-.385-.832-.772-1.25-1.162l-55.58-.432a5.99 5.99 0 1 0 0 11.978l66.134.182v-.391zm5.738 36.145a5.988 5.988 0 0 0-4.235 10.224 5.988 5.988 0 0 0 4.235 1.754l5.207-.042c.726-3.95.791-7.919.782-11.936h-5.989zm-2.468-25.081a6.108 6.108 0 0 0 2.228-2.95 71.72 71.72 0 0 1 5.151 16.052H95.075a5.99 5.99 0 0 1 0-11.978h29.947a6.112 6.112 0 0 0 3.521-1.124z",
    fill: "#FDFEFE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#kzc1uwqfie)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m62.58 76.147 25.39-27.26a7.313 7.313 0 0 1 10.337-.367 7.317 7.317 0 0 1 .366 10.34L68.758 90.98a7.302 7.302 0 0 1-6.104 2.29 7.283 7.283 0 0 1-4.567-1.74L46.94 82.056a7.317 7.317 0 0 1-.837-10.313 7.313 7.313 0 0 1 10.31-.837l6.167 5.242z",
    fill: "#FDFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9bqu1hjt4b",
    x1: 137,
    y1: 5,
    x2: 144.29,
    y2: 125.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l84qor77nc",
    x1: 96.824,
    y1: 135.03,
    x2: 23.001,
    y2: 119.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C16A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h0frbs3nza",
    x: 0,
    y: 0,
    width: 145,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.25098 0 0 0 0 0.454902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1509_9786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1509_9786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kzc1uwqfie",
    x: 41.362,
    y: 46.557,
    width: 62.274,
    height: 52.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.25098 0 0 0 0 0.454902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1509_9786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1509_9786",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessChecked);
export default __webpack_public_path__ + "static/media/successChecked.0088cf750c07b4c1f2b9ea08619d5011.svg";
export { ForwardRef as ReactComponent };